// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3qrLm","inputDescription":"styles_inputDescription__2rxEQ"};